import configJSON from 'config/config.json';

// const getWsHostUrl = (wsPath = 'basic') => {
// 	// eslint-disable-next-line no-undef

// 	// const runtimeHost = windows?.env?.REACT_APP_BACKEND_API_BASE_URL;
// 	// const fallbackHost = __BUILDMODE__ && __BUILDMODE__ === 'dev' && configJSON.host_dev ? configJSON.host_dev : configJSON.host;
// 	const host = __BUILDMODE__ && __BUILDMODE__ === 'dev' && configJSON.host_dev ? configJSON.host_dev : configJSON.host;
// 	let hostUrl;
// 	try {
// 		hostUrl = new URL(host);
// 	} catch (error) {
// 		if (error.name === 'TypeError') {
// 			hostUrl = new URL(window.location.origin);
// 		} else {
// 			console.error('couldnt create ws url', error);
// 		}
// 	}
// 	if (hostUrl.protocol === 'https:') {
// 		hostUrl.protocol = 'wss:';
// 	} else {
// 		hostUrl.protocol = 'ws:';
// 	}
// 	hostUrl.pathname = `/${wsPath}`;
// 	let urlStr = hostUrl.toString();
// 	if (!urlStr.endsWith('/')) {
// 		urlStr = `${urlStr}/`;
// 	}
// 	return urlStr;
// };

// export default getWsHostUrl;


const getWsHostUrl = (wsPath = 'basic') => {
	// eslint-disable-next-line no-undef

	const runtimeHost = window?.env?.REACT_APP_BACKEND_API_BASE_URL;
	const fallbackHost = __BUILDMODE__ && __BUILDMODE__ === 'dev' && configJSON.host_dev ? configJSON.host_dev : configJSON.host;
	// const host = __BUILDMODE__ && __BUILDMODE__ === 'dev' && configJSON.host_dev ? configJSON.host_dev : configJSON.host;
	// let hostUrl;
	const host = runtimeHost || fallbackHost
	let hostUrl;
	try {
		hostUrl = new URL(host);
	} catch (error) {
		if (error.name === 'TypeError') {
			hostUrl = new URL(window.location.origin);
		} else {
			console.error('couldnt create ws url', error);
		}
	}
	if (hostUrl.protocol === 'https:') {
		hostUrl.protocol = 'wss:';
	} else {
		hostUrl.protocol = 'ws:';
	}
	hostUrl.pathname = `/${wsPath}`;
	let urlStr = hostUrl.toString();
	if (!urlStr.endsWith('/')) {
		urlStr = `${urlStr}/`;
	}
	return urlStr;
};

export default getWsHostUrl;
